var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,14.1c0.6,0,1.1-0.5,1.1-1.1v0c0-0.6-0.5-1.1-1.1-1.1h-11c-0.6,0-1.1,0.5-1.1,1.1c0,0,0,0,0,0c0,0.6,0.5,1.1,1.1,1.1L17.5,14.1L17.5,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,16.3c-0.6,0-1.1,0.5-1.1,1.1v0c0,0.6,0.5,1.1,1.1,1.1H12v0c0.6,0,1.1-0.5,1.1-1.1c0,0,0,0,0,0c0-0.6-0.5-1.1-1.1-1.1H6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,2h-2.5v2.2h1.4v2.2h-1.4v1.9c0,0.1,0,0.2,0,0.3h1.5v13.2H3.2V8.6h11c0-0.1,0-0.2,0-0.3c0,0,0,0,0,0V6.4h-11V4.2h11V2H2.1C1.5,2,1,2.5,1,3.1v19.8v0C1,23.5,1.5,24,2.1,24h19.8c0,0,0,0,0,0c0.6,0,1.1-0.5,1.1-1.1V3.1c0,0,0,0,0,0C23,2.5,22.5,2,21.9,2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    d: "M16.3,10.1c0.2,0.3,0.5,0.4,0.8,0.2c0.1,0,0.1-0.1,0.2-0.2l0.6-0.9c0.1-0.1,0.1-0.2,0.1-0.3V0.6c0-0.3-0.3-0.6-0.6-0.6h-1.1c-0.3,0-0.6,0.3-0.6,0.6v8.3c0,0.1,0,0.2,0.1,0.3L16.3,10.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentEdit);
export default __webpack_public_path__ + "static/media/document_edit.40bc90f917228b2bdc8332e85018b560.svg";
export { ForwardRef as ReactComponent };